<template>

  <div class="mobile-status-info d-flex flex-column w-100 pr-2">

    <div
      class="mb-2"
      :class="(historicalAverage && historicalAverage.value) ? '' : 'border-bottom pb-3 ' ">
      <h2 class="h4 d-flex justify-content-between mb-0">
          <b-form-group class="mb-0" aria-label="Flow variable selector">
            <b-form-radio-group
              v-model="selectedOption"
              :options="radioOptions"
              buttons
              button-variant="outline-secondary"
              size="sm"
              name="radio-btn-outline">
            </b-form-radio-group>
          </b-form-group>
        <div class="d-flex">
          <div class="ml-auto mt-auto mb-auto flow-status-info-underline">
            <span class="flow-status-info-value">{{currentFlow && currentFlow.value}}</span><span class="flow-status-info-units"> {{currentFlow && currentFlow.units}}</span>
          </div>
        </div>
      </h2>
    </div>

    <div class="border-bottom mb-2"
      v-if="historicalAverage && historicalAverage.value">
      <h2
        class="h5 font-sm d-flex justify-content-between">
        <div class="font-weight-light">
          <small class="mt-auto mb-auto mt-auto">Historical Avg</small>
        </div>
        <div class="historical-average-underline">
          <span class="historical-average-value">{{historicalAverage.value}}</span><span class="historical-average-units"> {{historicalAverage.units}}</span>
        </div>
      </h2>
    </div>

    <div class="border-bottom mb-2"
      v-if="waterTemp && waterTemp.value">

      <h2
        class="h5 d-flex justify-content-between">
        <div class="status-info-block-legend d-flex">
          <small class=" mt-auto mb-auto font-weight-light">Water Temperature</small>
        </div>
        <div class="water-temp-underline">
          <span class="water-temp-value">{{waterTemp.value}}</span><span class="water-temp-units"> {{waterTemp.units}}</span>
        </div>
      </h2>
    </div>

  </div>

</template>

<script>

import constants from '@/constants';

export default {
  name: 'MobileStatusInfo',

  data() {
    return {
      selectedOption: ""
    };
  },

  props: ['currentFlow', 'historicalAverage', 'waterTemp', 'options'],

  data() {
    return {
      selectedOption  : constants.FlowVariables.Discharge.key,
    };
  },

  created() {
    if (this.options.indexOf(el => el.key === constants.FlowVariables.Discharge.key)) {
      this.selectedOption   = constants.FlowVariables.Discharge.key;
    } else {
      this.selectedOption   = constants.FlowVariables.GaugeHeight.key;
    }
  },

  computed: {

    // Options are of type constants.FlowVariables
    radioOptions() {
      return this.options.map(option => ({
        text: option.display,
        value: option.key
      }));
    },
  },

  watch: {

    /**
     * Weird pattern, yes.
     *
     * In use b/c I'm also using a Vue `model` property which has two-way binding.
     *
     * Which leads to a lot of weird shit, like this... perhaps there's a better way.
     */
    selectedOption() {
      this.$emit('flowVariableChanged', this.selectedOption);
    }
  }

};

</script>

<style lang="scss">

  .mobile-status-info {

      .flow-status-info-value,
      .flow-status-info-units {
        color: $osf-blue;
      }

      .water-temp-value,
      .water-temp-units {
        color: $osf-original-green;
      }

      .historical-average-value,
      .historical-average-units {
        color: $osf-dark-gray;
      }

      .flow-status-info-underline {
        border-bottom: 2px solid $osf-blue;
      }

      .historical-average-underline {
        border-bottom: 2px dashed $osf-dark-gray;
      }

      .water-temp-underline {
        border-bottom: 2px solid $osf-original-green;
      }

  }


</style>
